export const locale = {
    lang: 'nl',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': 'Authenticatie in twee stappen',
          'SUBTITULO': 'Om meer veiligheid te bieden bij het betreden van het platform, is het noodzakelijk dat u authenticatie in twee stappen uitvoert, zoals hieronder aangegeven:',
          'BOTONES': {
            'SIGUIENTE': 'De volgende',
            'ANTERIOR': 'Vorige'
          },
          'PASOS': {
            '1': {
              'TITULO': 'Stap 1',
              'INSTRUCCION': 'Scan de QR-code met de Google Authenticator mobiele app en klik op de volgende knop',
              'REGISTRADO': 'Er is gedetecteerd dat uw e-mailadres al is geregistreerd in de Google Authenticator-toepassing, het is niet nodig om de QR-code opnieuw te scannen, ga verder met de volgende stap'
            },
            '2': {
              'TITULO': 'Stap 2',
              'INSTRUCCION': 'Voer de door Google Authenticator verstrekte sleutel in en klik op volgende ',
              'INPUT': 'Sleutel verkregen',
              'INFOPREVIA': {
                'INFO_1': 'Er is gedetecteerd dat u al toegang hebt gekregen tot het platform vanaf deze computer. U hoeft de QR-code niet opnieuw te scannen',
                'INFO_2': 'Voer gewoon het wachtwoord in dat door Google Authenticator voor uw account is verstrekt en klik op volgende',
                'INFO_3': 'Als u de QR-code opnieuw wilt scannen, klikt u op de knop Vorige',
                'INFO_4': 'Waarschuwing: door dit te doen, moet u uw account opnieuw aan Google Authenticator koppelen',
              }
            },
            '3': {
              'TITULO': 'Resultaat',
              'INSTRUCCION': 'Voer de sleutel in die is verkregen uit de QR-code in de vorige stap en klik op de knop Volgende',
              'VALIDANDO': 'Valideren van de ingevoerde sleutel, wacht even',
              'MAL': 'De sleutel is onjuist of is verlopen, voer de sleutel opnieuw in en probeer het opnieuw',
              'BIEN': 'Je hebt de authenticatie met succes voltooid, dan kom je op het platform'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'Voer uw e-mailadres in, we sturen u een link om uw wachtwoord te wijzigen',
          'BTN':'E-mail verzenden',
          'PLACERHOLDER':'E-mailadres',
          'ERROR':'We hebben uw e-mailadres niet gevonden. Probeer een ander e-mailadres',
          'TRUE':'De e-mail is verzonden. Controleer uw inbox of de spammap'
        },
        'RESET':{
          'LABEL01':'Voer alstublieft uw nieuwe wachtwoord in voor de gebruiker:   ',
          'LABEL02':'Wachtwoord',
          'LABEL03':'Geef nogmaals het wachtwoord',
          'BTN':'Wachtwoord wijzigen',
          'ERROR':'Fout, het token is niet gevonden',
          'NOPASSWORDMATCH':'Het wachtwoord komt niet overeen',
          'CARACTERES':'Moet minimaal 3 tekens lang zijn',
          'SUCCESSCHANGE':'Uw wachtwoord is correct gewijzigd'
        },
        'LANDING': {
          'MENSAJE': 'Welcome',
          'NAVEG': ''
          //'NAVEG': 'The use of <a class='linkChrome' href='https://www.google.com/intl/es-419/chrome/' target='blank'>Google Chrome</a> browser is recommended'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': 'Important announcement.',
            'TEXTO': `Beste gebruiker:<br><br>
             U wordt geïnformeerd dat, om een betere service te bieden, een update van het Cultural GO-platform zal worden uitgevoerd om de werking ervan te optimaliseren.<br><br>
             De update vindt plaats op <strong>vrijdag 23 juli vanaf 23:59 uur. tot 23:59 uur op zaterdag 24 juli</strong>. Gedurende die periode blijft het platform inactief. De huidige enquêtes blijven echter actief.<br><br>`
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'Wachtwoord herstel',
          'LOGIN':'Log in',
          'TITULO': 'LOG IN OP UW ACCOUNT',
          'INPUT':{
            'EMAIL': 'E-mail',
            'PASSWORD': 'Wachtwoord',
            'LANGSEL': 'Kies een taal'
          },
          'VAL': {
            'NOTEMAIL': 'Email is verplicht ',
            'INVEMAIL': 'Vul een geldig e-mailadres in ',
            'CARACT_EMA': 'Veld staat de volgende tekens niet toe /&¿+#$%([=])*?<>:\'',
            // 'PASS': ' Een wachtwoord is verplicht ',
            'PASS': 'Ongeldig wachtwoord',
          },
          'SIGNIN': 'GA!',
          'CAMBIALOGO': 'Klik hier om uw bedrijfslogo te wijzigen',
          'CARGAOK': 'Uw bedrijfslogo is correct geladen',
          'CARGANULL': 'Er is een fout opgetreden bij het laden van uw bedrijfslogo',
          'CARGAERROR': 'Het formaat van het geselecteerde bestand is niet correct. Alleen formaten worden geaccepteerd: jpg, png, gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INLOGGEN OP UW ACCOUNT',
          'INPUT':{
            'PASSWORD': 'Wachtwoord:',
            'LANGSEL': 'Kies een taal:',
            'LOGIN': 'Login',
          },

      },
      'INTRO-LOGIN':{
        'TITULO': 'INSTRUCTIES',
        'TEXT1': 'Great Place to Work® Institute. heet u welkom om uw onderzoek naar het werkklimaat 100% vertrouwelijk te beantwoorden.',
        'TEXT2': 'Vertrouwelijkheid',
        'TEXT3': 'Op het Instituut:',
        'TEXT4': 'wij administreren, verwerken en analyseren de reacties per organisatie en per gebied',
        'TEXT5': 'We genereren wereldwijde resultaten die de verbeteracties in het organisatieklimaat aangeven',
        'TEXT6': 'je kent de individuele antwoorden niet',
        'TEXT7': 'Individuele antwoorden zijn strikt vertrouwelijk',
        'TEXT8': 'Klachten en suggesties',
         'TEXT9': 'Het is ten strengste verboden:',
         'TEXT10': 'om u op enigerlei wijze te beïnvloeden, te bestraffen of te beletten de enquête vrijelijk in te vullen',
         'TEXT11': 'Wij stellen de volgende mail ter beschikking voor klachten of suggesties:',
         'TEXT12': 'mx_transparencia@greatplacetowork.com',
         'TEXT13': 'Instructies:',
         'TEXT14':'1. Voer uw ',
         'TEXT15': 'werknemersnummer + geboortejaar',
         'TEXT16':'2. Laat geen losse flodders achter.',
         'TEXT17':'3. Klik op Start',
         'TEXT18': 'Help ons de enquête van het Great Place to Work® Institute te beantwoorden'
      }

    },
    'LOADING':{
      'TEXT_WELCOM':'Welkom bij CulturalGo',
    'TEXT_CHANGE':'Informatie aan het laden...',
    }
    }
};
